import React from "react";
// 🔷 Components Import
import Newhome from "./Newhome"; // Header + Banner
import BannerProgram from "./BannerProgram";
import AbdmKeyFeature from "./AbdmKeyFeature";
import Intigrationfaq from "./Intigrationfaq";
import Newhomefooter from "./Newhomefooter";
import Aboutacross from "./Aboutacross";
import ProgramSection from "./ProgramSection";
import Fullbanner from "./Fullbanner";

const Newhomepage = () => {

  return (
    <>
      <div className="home-page-new">
        {/* 🔷 HEADER + HERO */}
        <Newhome />

      {/* 🔷 PROGRAM SECTION */}
      {/* <BannerProgram /> */}
      <Fullbanner />
      {/* Aboutacross Section */}
      <Aboutacross />
      {/* 🔷 ABDM + KEY FEATURES */}
      {/* Program Section */}
      <ProgramSection />
      <AbdmKeyFeature />

        {/* 🔷 INTEGRATION + FAQ */}
        <Intigrationfaq />

        <Newhomefooter />
      </div>

    </>
  );
};

export default Newhomepage;